import { createApp } from "vue";
import ArticleShareModal from "~/components/Users/ArticleShareModal";
document.addEventListener("DOMContentLoaded", () => {
  const app = createApp({ components: { ArticleShareModal } });
  app.mount("#article_share_modal");
});
